import React, { useEffect, useState } from 'react';
import DataService from "../../../services/data.service";
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { ItemTypeIdProps } from '../../../types/IdProps';
import AddItemTypeBomRestrictionPopup from '../Popups/ItemType_popup_AddBomRestriction';

const ItemType_tab_BomRestrictions: React.FC<ItemTypeIdProps> = ({ itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemTypeBomRestrictions/ByItemType/' + itemTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemTypeBomRestrictions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'ItemType', dataProp: 'allowedItemType.name', sort:'asc' },
        { title: 'Category', dataProp: 'allowedProductCategory.name' },
        { title: 'Required', dataProp: 'required', dataType: 'bool' },
        { title: 'Suggest', dataProp: 'suggest', dataType: 'bool' },
        { title: 'Allow multiple', dataProp: 'allowMultiple', dataType: 'bool' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditItemType, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemTypeBomRestrictions'
                tableData={data}
                colInfos={colInfos}
                navigateTitle='BOM restriction'
                navigateUrl='/plm/ItemSetup/ItemTypeBomRestriction/'
            />
            {showPopup && <AddItemTypeBomRestrictionPopup itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemType_tab_BomRestrictions;